// extracted by mini-css-extract-plugin
export default {"wrapperGameHeader":"CasinoGame_wrapperGameHeader__JVFlm","recommendedWrapper":"CasinoGame_recommendedWrapper__iW+2m","center":"CasinoGame_center__FvFTC"};